import React, { useState } from "react";
import DialogWrapper from "./DialogWrapper";
import { formatDocumentNumber, formatDocumentType, formatFullAddress, formatFullBirthDate, formatFullEmail, formatTelephoneNumbers } from "../../helpers/format";
import dayjs from "dayjs";
import { genderMap, maritalStatusMap } from "../../helpers/mapping";
import AttributeResponsive from "../dataitem/AttributeResponsive";

const DialogRequest = ({ open, request, closeMethod }) => {

    const cancel = () => { closeMethod() };

    if (!Boolean(request)) return null;

    const telephoneNumbers = formatTelephoneNumbers(request.phoneNrMobilePrimary, request.phoneNrMobileSecondary);
    const genderOpt = genderMap().reduce((obj, item) => { obj[item.id] = item.label; return obj; }, {});
    const maritalStatusOpt = maritalStatusMap().reduce((obj, item) => { obj[item.id] = item.label; return obj; }, {});

    return (
        <DialogWrapper
            maxWidth="md"
            open={open}
            onClose={cancel}
            title="Pedido de Membro"
            onCancel={cancel}
            labelCancel="Fechar"
        >
            <AttributeResponsive label="Nome Completo" value={request.fullName} />
            <AttributeResponsive label="Nome Curto" value={request.shortName} />
            <AttributeResponsive label="Email" value={formatFullEmail(request.email, request.paymentEmail)} />
            <AttributeResponsive label="NIF" value={request.fiscalNumber ?? "-"} />
            <AttributeResponsive label="Morada" value={formatFullAddress(request.address, request.postCode, request.town)} />
            <AttributeResponsive label={formatDocumentType(request.idCardType)} value={formatDocumentNumber(request.identificationNumber, request.idCardValidity)} />
            <AttributeResponsive label="Telefone" value={Boolean(telephoneNumbers) ? telephoneNumbers : "-"} />
            <AttributeResponsive label="Género" value={genderOpt[request.gender]} />

            <AttributeResponsive label="Data de Nascimento" value={formatFullBirthDate(request.birthDate)} />
            <AttributeResponsive label="Naturalidade" value={request.placeOfBirth} />
            <AttributeResponsive label="Nacionalidade" value={request.nationality} />
            <AttributeResponsive label="Profissão" value={request.job} />
            <AttributeResponsive label="Estado Civil" value={maritalStatusOpt[request.maritalStatus]} />
            <AttributeResponsive label="Nome do Pai" value={request.fatherName} />
            <AttributeResponsive label="Nome da Mãe" value={request.motherName} />

            <AttributeResponsive label="Data do Pedido" value={dayjs(request.createdAt).format("DD MMM YY HH:mm")} borderBottom={false} />

        </DialogWrapper>
    );
}

export default DialogRequest;
